"use strict";
'use es6'; // to be kept in sync with https://git.hubteam.com/HubSpot/IdentityBase/blob/56bf8179d8cb2a21e1cfcc38224c34a36f991e0a/src/main/protobuf/properties.proto#L1
// (link is to commit as of 1/8/2020, check file at latest master for updates)

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SCORE = exports.ROLLUP = exports.EQUATION = exports.CALCULATION = exports.TEXTAREA = exports.TEXT = exports.SELECT = exports.RADIO = exports.NUMBER = exports.FILE = exports.DATE = exports.CHECKBOX = exports.BOOLEAN_CHECKBOX = void 0;
var BOOLEAN_CHECKBOX = 'booleancheckbox';
exports.BOOLEAN_CHECKBOX = BOOLEAN_CHECKBOX;
var CHECKBOX = 'checkbox';
exports.CHECKBOX = CHECKBOX;
var DATE = 'date';
exports.DATE = DATE;
var FILE = 'file';
exports.FILE = FILE;
var NUMBER = 'number';
exports.NUMBER = NUMBER;
var RADIO = 'radio';
exports.RADIO = RADIO;
var SELECT = 'select';
exports.SELECT = SELECT;
var TEXT = 'text';
exports.TEXT = TEXT;
var TEXTAREA = 'textarea';
exports.TEXTAREA = TEXTAREA;
var CALCULATION = 'calculation';
exports.CALCULATION = CALCULATION;
var EQUATION = 'calculation_equation';
exports.EQUATION = EQUATION;
var ROLLUP = 'calculation_rollup';
exports.ROLLUP = ROLLUP;
var SCORE = 'calculation_score';
exports.SCORE = SCORE;